import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Divider from "@mui/material/Divider";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

import {
  getFilteredOptions,
  getFilteredShareUrlOptions,
  getInitialFilteredOptions,
} from "./OtherFunctions";
import { Typography } from "@mui/material";
import DynamicHashTextField from "../DynamicHashTextField/DynamicHashTextField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const EditNodeForm = ({
  myTreeData,
  title,
  information,
  handleCreateModalClose,
  handleSubmitForm,
  handleTempSubmitForm,
  moduleName,
  moduleFields,
  leadFields,
}) => {
  const [shareUrlModalOpen, setShareUrlModalOpen] = useState(false);
  const [shareFullaccessUrlModalOpen, setShareFullaccessUrlModalOpen] =
    useState(false);
  const [collectionLinkModalOpen, setCollectionLinkModalOpen] = useState(false);

  const handleShareUrlModalOpen = () => setShareUrlModalOpen(true);
  const handleShareUrlModalClose = () => {
    setShareUrlModalOpen((prev) => false);
  };

  const handleShareFullaccessUrlModalOpen = () =>
    setShareFullaccessUrlModalOpen(true);
  const handleShareFullaccessUrlModalClose = () => {
    setShareFullaccessUrlModalOpen((prev) => false);
  };

  const handleCollectionLinkModalOpen = () => setCollectionLinkModalOpen(true);
  const handleCollectionLinkModalClose = () => {
    setCollectionLinkModalOpen((prev) => false);
  };

  const [count, setCount] = useState(0);
  const {
    register,
    getValues,
    setValue,
    resetField,
    control,
    handleSubmit,
    watch,
  } = useForm({
    defaultValues: {
      title: title,
      information: { ...information },
    },
  });
  const onSubmit = (data) => {
    handleSubmitForm(data);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      //  style={{ backgroundColor: "red" }}
    >
      <header>
        <Typography sx={{ fontWeight: 500, fontSize: "24px" }}>
          Folder Structure Setting
        </Typography>
      </header>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box
            sx={{
              mb: ".5rem",
              "& .MuiFormControl-root": {
                width: "100% !important",
              },
            }}
          >
            <Box sx={{ height: "38px", display: "flex", alignItems: "center" }}>
              <Typography>Folder Name</Typography>
            </Box>
            <Controller
              name="title"
              control={control}
              rules={{
                required: "The Field is required",
              }}
              render={({ field, fieldState, formState }) => (
                <DynamicHashTextField
                  module={moduleName}
                  fields={moduleFields}
                  initialValue={title}
                  savedData={(data) => {
                    field.onChange(data);
                  }}
                />
              )}
            />
          </Box>

          <Box sx={{ mb: ".5rem" }}>
            <Controller
              name="information.saveFolder.isChecked"
              control={control}
              render={({ field, fieldState, formState }) => (
                <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={field.value}
                        {...field}
                        disableRipple
                        size="small"
                        disabled={watch(
                          "information.moveFolderIfExist.isChecked"
                        )}
                        onChange={(event) => {
                          // if (!event?.target?.checked) {
                          //   setValue('information.saveFolder.value', null);
                          // }
                          // setValue(`information.saveFolder.value`, null);
                          // reset({
                          //   firstName: "bill",
                          //   lastName: "luo",
                          // })
                          // resetField("information.saveFolder.value")
                          setValue("information.saveFolder.value", null);
                          field.onChange(event?.target?.checked);
                          handleTempSubmitForm(getValues());
                        }}
                      />
                    }
                    label="Save Folder?"
                  />
                </>
              )}
            />

            <Controller
              name="information.saveFolder.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <>
                  {fieldState.defaultValue}
                  <Autocomplete
                    autoHighlight={true}
                    size="small"
                    options={getFilteredOptions(
                      getInitialFilteredOptions(
                        moduleFields,
                        myTreeData[0],
                        [],
                        0
                      ),
                      watch("information")
                    )}
                    defaultValue={information?.saveFolder?.value}
                    groupBy={(option) => option?.lookupDisplayLabel}
                    getOptionLabel={(option) => option?.fieldDisplayLabel}
                    disableClearable={true}
                    onChange={(e, value) => {
                      field.onChange(value);
                      handleTempSubmitForm(getValues());
                    }}
                    disabled={!watch("information.saveFolder.isChecked")}
                    value={
                      watch("information.saveFolder.isChecked")
                        ? field?.value
                        : null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Fields"
                        required={watch("information.saveFolder.isChecked")}
                      />
                    )}
                  />
                </>
              )}
            />
          </Box>
          {["Contacts", "Accounts", "Deals"]?.includes(moduleName) && (
            <Box sx={{ mb: ".5rem" }}>
              <Controller
                name="information.copyLeadFolder.isChecked"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={field.value}
                          {...field}
                          disableRipple
                          size="small"
                          onChange={(event) => {
                            // if (!event?.target?.checked) {
                            //   setValue('information.saveFolder.value', null);
                            // }
                            // setValue(`information.saveFolder.value`, null);
                            // reset({
                            //   firstName: "bill",
                            //   lastName: "luo",
                            // })
                            // resetField("information.saveFolder.value")
                            setValue("information.copyLeadFolder.value", null);
                            field.onChange(event?.target?.checked);
                          }}
                        />
                      }
                      label="Copy Lead Folder?"
                    />
                  </>
                )}
              />

              <Controller
                name="information.copyLeadFolder.value"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <>
                    {fieldState.defaultValue}
                    <Autocomplete
                      autoHighlight={true}
                      size="small"
                      options={leadFields}
                      defaultValue={information?.copyLeadFolder?.value}
                      groupBy={(option) => option?.lookupDisplayLabel}
                      getOptionLabel={(option) => option?.fieldDisplayLabel}
                      disableClearable={true}
                      onChange={(e, value) => {
                        field.onChange(value);
                      }}
                      disabled={!watch("information.copyLeadFolder.isChecked")}
                      value={
                        watch("information.copyLeadFolder.isChecked")
                          ? field?.value
                          : null
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Leads Field where Folder ID is Saved"
                          required={watch(
                            "information.copyLeadFolder.isChecked"
                          )}
                        />
                      )}
                    />
                  </>
                )}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ mb: ".5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Controller
                name="information.shareUrl.isChecked"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          size="small"
                          disableRipple
                          onChange={(event) => {
                            // if (!event?.target?.checked) {
                            //   setValue('information.shareUrl.value', null);
                            // }
                            setValue("information.shareUrl.value", null);
                            setValue("information.shareUrl.password", null);
                            setValue("information.shareUrl.duration", null);
                            field.onChange(event?.target?.checked);
                            handleShareUrlModalOpen();
                            handleTempSubmitForm(getValues());
                          }}
                        />
                      }
                      label="Save Share Url (Download Only)?"
                    />
                  </>
                )}
              />
              <Button
                onClick={handleShareUrlModalOpen}
                sx={{ textTransform: "capitalize" }}
              >
                More Settings
              </Button>
            </Box>

            <Controller
              name="information.shareUrl.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.shareUrl?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disabled={!watch("information.shareUrl.isChecked")}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);
                    handleTempSubmitForm(getValues());
                  }}
                  value={
                    watch("information.shareUrl.isChecked")
                      ? field?.value
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Fields"
                      required={watch("information.shareUrl.isChecked")}
                      disabled={!watch("information.shareUrl.isChecked")}
                    />
                  )}
                />
              )}
            />
          </Box>
          <Box sx={{ mb: ".5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Controller
                name="information.fullAccessShareUrl.isChecked"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          disableRipple
                          {...field}
                          checked={field.value}
                          onChange={(event) => {
                            setValue( "information.fullAccessShareUrl.value", null);
                            setValue( "information.fullAccessShareUrl.password", null);
                            setValue( "information.fullAccessShareUrl.duration", null);
                            field.onChange(event?.target?.checked);
                            handleShareFullaccessUrlModalOpen();
                            handleTempSubmitForm(getValues());
                          }}
                        />
                      }
                      label="Save Share Url (Full Access)?"
                    />
                  </>
                )}
              />
              <Button
                onClick={handleShareFullaccessUrlModalOpen}
                sx={{ textTransform: "capitalize" }}
              >
                More Settings
              </Button>
            </Box>

            <Controller
              name="information.fullAccessShareUrl.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.fullAccessShareUrl?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);

                    handleTempSubmitForm(getValues());
                  }}
                  disabled={!watch("information.fullAccessShareUrl.isChecked")}
                  // value={field?.value}
                  value={
                    watch("information.fullAccessShareUrl.isChecked")
                      ? field?.value
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Fields"
                      required={watch(
                        "information.fullAccessShareUrl.isChecked"
                      )}
                      disabled={!watch("information.fullAccessShareUrl.isChecked")}
                    />
                  )}
                />
              )}
            />
          </Box>
          <Box sx={{ mb: ".5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Controller
                name="information.collectionLink.isChecked"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          disableRipple
                          {...field}
                          checked={field.value}
                          onChange={(event) => {
                            // if (!event?.target?.checked) {
                            //   setValue('information.fullAccessShareUrl.value', null);
                            // }
                            setValue("information.collectionLink.value", null);
                            setValue(
                              "information.collectionLink.duration",
                              null
                            );
                            field.onChange(event?.target?.checked);
                            handleCollectionLinkModalOpen();
                            handleTempSubmitForm(getValues());
                          }}
                        />
                      }
                      label="Save link for file collection?"
                    />
                  </>
                )}
              />
              <Button
                onClick={handleCollectionLinkModalOpen}
                sx={{ textTransform: "capitalize" }}
              >
                More Settings
              </Button>
            </Box>
            <Controller
              name="information.collectionLink.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.collectionLink?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);

                    handleTempSubmitForm(getValues());
                  }}
                  disabled={!watch("information.collectionLink.isChecked")}
                  value={field?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Fields"
                      required={watch("information.collectionLink.isChecked")}
                    />
                  )}
                />
              )}
            />
          </Box>
        </Grid>
      </Grid>
      <Divider
        sx={{
          mt: ".4rem",
          mb: ".8rem",
        }}
      />

      <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
        Additional Information
      </Typography>

      <Box>
        <Controller
          name="information.usePreviousFolder.isChecked"
          control={control}
          render={({ field, fieldState, formState }) => (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    disableRipple
                    {...field}
                    checked={field.value}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setValue(
                          "information.moveFolderIfExist.isChecked",
                          false
                        );
                        setCount(count + 1);
                      }
                      field.onChange(event?.target?.checked);
                    }}
                  />
                }
                label="Use Existing Folder?"
              />
            </>
          )}
        />
      </Box>

      <Box>
        <Controller
          name="information.moveFolderIfExist.isChecked"
          control={control}
          render={({ field, fieldState, formState }) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  disableRipple
                  {...field}
                  checked={field.value}
                  onChange={(event) => {
                    if (event?.target?.checked) {
                      setValue("information.saveFolder.isChecked", true);
                      setValue(
                        "information.usePreviousFolder.isChecked",
                        false
                      );
                      setCount(count + 1);
                    }
                    field.onChange(event?.target?.checked);
                  }}
                />
              }
              label="Move Folder to New Location If Exist"
            />
          )}
        />
      </Box>

      <Box sx={{ display: "flex", gap: "1rem", justifyContent: "end" }}>
        <Button
          type="button"
          variant="outlined"
          size="small"
          disableRipple
          sx={{ textTransform: "capitalize" }}
          onClick={handleCreateModalClose}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="small"
          disableRipple
          sx={{ textTransform: "capitalize" }}
        >
          Save
        </Button>
      </Box>

      <Modal
        open={watch("information.shareUrl.isChecked") && shareUrlModalOpen}
        onClose={handleShareUrlModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <>
            <Typography sx={{ fontWeight: 500, fontSize: "18px", mb: "1rem" }}>
              Save Share Url (Download Only)
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
              Select Fields
            </Typography>
            <Controller
              name="information.shareUrl.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  sx={{ mb: ".5rem" }}
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.shareUrl?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disabled={!watch("information.shareUrl.isChecked")}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);
                    handleTempSubmitForm(getValues());
                  }}
                  value={
                    watch("information.shareUrl.isChecked")
                      ? field?.value
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Select Fields"
                      required={watch("information.shareUrl.isChecked")}
                      disabled={!watch("information.shareUrl.isChecked")}
                    />
                  )}
                />
              )}
            />
            <Box sx={{ mb: ".5rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Password for Share Url
              </Typography>
              <Controller
                name="information.shareUrl.password"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <DynamicHashTextField
                    module={moduleName}
                    fields={moduleFields}
                    // initialValue={information?.shareUrl?.password || ""}
                    initialValue={field?.value || ""}
                    width={"100%"}
                    savedData={(data) => {
                      field.onChange(data);
                    }}
                  />
                )}
              />
            </Box>
            <Box sx={{ mb: "1rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Access Duration in days
              </Typography>
              <Controller
                name="information.shareUrl.duration"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <TextField
                    sx={{ width: "100%" }}
                    size="small"
                    // label="days"
                    id="outlined-number"
                    type="number"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    minLength={0}
                    value={
                      watch("information.shareUrl.isChecked")
                        ? field?.value
                        : null
                    }
                    onChange={(event) => {
                      if (Number(event?.target?.value) <= 0) {
                        setValue("information.shareUrl.duration", null);
                        field.onChange(null);
                      } else {
                        setValue(
                          "information.shareUrl.duration",
                          Number(event?.target?.value)
                        );
                        field.onChange(Number(event?.target?.value));
                      }
                    }}
                  />
                )}
              />
            </Box>

            <Box
              sx={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="outlined"
                size="small"
                onClick={handleCreateModalClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="contained"
                size="small"
                disabled={
                  getValues()?.information?.shareUrl?.duration &&
                  getValues()?.information?.shareUrl?.duration <= 0
                }
                onClick={handleShareUrlModalClose}
              >
                Save
              </Button>
            </Box>
          </>
        </Box>
      </Modal>

      <Modal
        open={
          watch("information.fullAccessShareUrl.isChecked") &&
          shareFullaccessUrlModalOpen
        }
        onClose={handleShareFullaccessUrlModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <>
            <Typography sx={{ fontWeight: 500, fontSize: "18px", mb: "1rem" }}>
              Save Share Url (Full Access)
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
              Select Fields
            </Typography>
            <Controller
              name="information.fullAccessShareUrl.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  sx={{ mb: ".5rem" }}
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.fullAccessShareUrl?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);
                    handleTempSubmitForm(getValues());
                  }}
                  disabled={!watch("information.fullAccessShareUrl.isChecked")}
                  value={
                    watch("information.fullAccessShareUrl.isChecked")
                      ? field?.value
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Select Fields"
                      required={watch(
                        "information.fullAccessShareUrl.isChecked"
                      )}
                      disabled={!watch("information.fullAccessShareUrl.isChecked")}
                    />
                  )}
                />
              )}
            />
            <Box sx={{ mb: ".5rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Password for Share Url
              </Typography>
              <Controller
                name="information.fullAccessShareUrl.password"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <DynamicHashTextField
                    module={moduleName}
                    fields={moduleFields}
                    // initialValue={information?.fullAccessShareUrl?.password || ""}
                    initialValue={field?.value || ""}
                    width={"100%"}
                    savedData={(data) => {
                      field.onChange(data);
                    }}
                  />
                )}
              />
            </Box>

            <Box sx={{ mb: "1rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Access Duration in days
              </Typography>
              <Controller
                name="information.fullAccessShareUrl.duration"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <TextField
                    sx={{ width: "100%" }}
                    size="small"
                    // label="days"
                    id="outlined-number"
                    type="number"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    minLength={0}
                    value={
                      watch("information.fullAccessShareUrl.isChecked")
                        ? field?.value
                        : null
                    }
                    // onChange={(event) => {
                    //   setValue(
                    //     "information.fullAccessShareUrl.duration",
                    //     Number(event?.target?.value)
                    //   );
                    //   field.onChange(Number(event?.target?.value));
                    // }}

                    
                    onChange={(event) => {
                      if (Number(event?.target?.value) <= 0) {
                        setValue("information.fullAccessShareUrl.duration", null);
                        field.onChange(null);
                      } else {
                        setValue(
                          "information.fullAccessShareUrl.duration",
                          Number(event?.target?.value)
                        );
                        field.onChange(Number(event?.target?.value));
                      }
                    }}
                  />
                )}
              />
            </Box>

            <Box
              sx={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="outlined"
                size="small"
                onClick={handleCreateModalClose}
              >
                Cancel
              </Button>

              <Button
                sx={{ textTransform: "capitalize" }}
                variant="contained"
                size="small"
                disabled={
                  getValues()?.information?.fullAccessShareUrl?.duration &&
                  getValues()?.information?.fullAccessShareUrl?.duration <= 0
                }
                onClick={handleShareFullaccessUrlModalClose}
              >
                Save
              </Button>
            </Box>
          </>
        </Box>
      </Modal>

      <Modal
        open={
          watch("information.collectionLink.isChecked") &&
          collectionLinkModalOpen
        }
        onClose={handleCollectionLinkModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <>
            <Typography sx={{ fontWeight: 500, fontSize: "18px", mb: "1rem" }}>
              Save link for file collection
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
              Select Fields
            </Typography>
            <Controller
              name="information.collectionLink.value"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  sx={{ mb: ".5rem" }}
                  autoHighlight={true}
                  size="small"
                  options={getFilteredShareUrlOptions(
                    getInitialFilteredOptions(
                      moduleFields,
                      myTreeData[0],
                      [],
                      0
                    ),
                    watch("information")
                  )}
                  defaultValue={information?.collectionLink?.value}
                  groupBy={(option) => option?.lookupDisplayLabel}
                  getOptionLabel={(option) => option?.fieldDisplayLabel}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);

                    handleTempSubmitForm(getValues());
                  }}
                  disabled={!watch("information.collectionLink.isChecked")}
                  value={field?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Select Fields"
                      required={watch("information.collectionLink.isChecked")}
                    />
                  )}
                />
              )}
            />
            <Box sx={{ mb: ".5rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Collection Link Name
              </Typography>

              <Controller
                name="information.collectionLink.name"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <DynamicHashTextField
                    module={moduleName}
                    fields={moduleFields}
                    initialValue={information?.collectionLink?.name || ""}
                    width={"100%"}
                    savedData={(data) => {
                      field.onChange(data);
                    }}
                  />
                )}
              />
            </Box>

            <Box sx={{ mb: "1rem" }}>
              <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                Access Duration in days
              </Typography>
              <Controller
                name="information.collectionLink.duration"
                control={control}
                render={({ field, fieldState, formState }) => (
                  <TextField
                    sx={{ width: "100%" }}
                    size="small"
                    // label="days"
                    id="outlined-number"
                    type="number"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    minLength={0}
                    value={
                      watch("information.collectionLink.isChecked")
                        ? field?.value
                        : null
                    }
                    onChange={(event) => {
                      setValue(
                        "information.collectionLink.duration",
                        Number(event?.target?.value)
                      );
                      field.onChange(Number(event?.target?.value));
                    }}
                  />
                )}
              />
            </Box>

            <Box
              sx={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="outlined"
                size="small"
                onClick={handleCreateModalClose}
              >
                Cancel
              </Button>

              <Button
                sx={{ textTransform: "capitalize" }}
                variant="contained"
                size="small"
                disabled={
                  getValues()?.information?.collectionLink?.duration &&
                  getValues()?.information?.collectionLink?.duration <= 0
                }
                onClick={handleCollectionLinkModalClose}
              >
                Save
              </Button>
            </Box>
          </>
        </Box>
      </Modal>
    </form>
  );
};

export default EditNodeForm;
